export default __webpack_public_path__ + "static/media/client-3.1326334c.png";